// Affiliate Marketing / Referral Program Email Generator
// Professional design with trust elements

const HAPPY_FAMILY_IMAGE = "https://images.unsplash.com/photo-1758523671893-0ba21cf4260f?w=600&q=80";
const MOVING_BOXES_IMAGE = "https://images.unsplash.com/photo-1600725935160-f67ee4f6084a?w=600&q=80";

const generateAffiliateMarketingEmailHTML = (data) => {
  const {
    customer_name = "Valued Customer",
    referral_amount = "100",
    friend_discount = "25",
    referral_code = "",
    company_phone = "0330 043 4791",
    company_email = "office@homego-removals.com",
    company_website = "www.homego-removals.com",
    consultant_name = "Thomas Jacobs",
    consultant_title = "Customer Consultant",
    company_reg_number = "16811153",
    insurance_amount = "£50,000",
    // Customizable content
    headline = "Earn £100 For Every Friend You Refer!",
    intro_message = "Thank you for choosing HomeGo Removals! We hope your move went smoothly. As a valued customer, we'd love for you to share your experience with friends, family, and neighbours.",
    how_it_works_1 = "Share your unique referral code with friends, family or neighbours who need moving services",
    how_it_works_2 = "When they book with us and mention your code, they get £25 OFF their move",
    how_it_works_3 = "Once their move is complete, we send YOU £100 cash - bank transfer or cash!",
    terms_conditions = "Referral must be a new customer. Reward paid within 7 days of completed move. No limit on referrals!",
    // Social sharing
    share_message = "I just moved with HomeGo Removals and they were amazing! Use my code for £25 off:",
  } = data;

  // Generate a referral code if not provided
  const refCode = referral_code || `HOMEGO-${customer_name.split(' ')[0].toUpperCase().slice(0,4)}${Math.floor(Math.random() * 1000)}`;
  
  // URL encode the share message for social links
  const encodedShareMsg = encodeURIComponent(`${share_message} ${refCode}`);
  const whatsappLink = `https://wa.me/?text=${encodedShareMsg}`;
  const smsLink = `sms:?body=${encodedShareMsg}`;

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>HomeGo Referral Program - Earn £${referral_amount}</title>
  <style>
    @media screen and (max-width: 620px) {
      .mobile-full { width: 100% !important; }
      .mobile-padding { padding: 15px !important; }
      .mobile-stack { display: block !important; width: 100% !important; margin-bottom: 10px !important; }
      .mobile-center { text-align: center !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background: linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%); font-family: 'Segoe UI', Arial, sans-serif;">
  
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background: linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%);">
    <tr>
      <td align="center" style="padding: 30px 15px;">
        
        <table role="presentation" width="600" cellspacing="0" cellpadding="0" border="0" style="max-width: 600px;">
          
          <!-- PREMIUM HEADER -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 20px 20px 0 0; padding: 0;">
              <!-- Gold accent bar -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="background: linear-gradient(90deg, #D4AF37 0%, #F4D03F 50%, #D4AF37 100%); height: 4px; border-radius: 20px 20px 0 0;"></td>
                </tr>
              </table>
              
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="padding: 25px 30px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <h1 style="margin: 0; font-size: 28px; font-weight: 800; letter-spacing: -1px;">
                            <span style="color: #D4AF37;">Home</span><span style="color: #FFFFFF;">Go</span>
                          </h1>
                          <p style="margin: 3px 0 0; font-size: 10px; color: #D4AF37; letter-spacing: 2px; text-transform: uppercase;">Removals & Packing Ltd</p>
                        </td>
                        <td align="right">
                          <table border="0" cellpadding="0" cellspacing="0">
                            <tr>
                              <td style="background: rgba(0, 182, 122, 0.15); border: 1px solid #00B67A; border-radius: 20px; padding: 6px 12px;">
                                <span style="color: #00B67A; font-size: 14px; letter-spacing: 1px;">★★★★★</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- HERO SECTION -->
          <tr>
            <td style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); padding: 40px 30px; text-align: center;">
              <p style="margin: 0 0 8px; font-size: 12px; color: #000; text-transform: uppercase; letter-spacing: 3px; opacity: 0.8;">Exclusive Referral Program</p>
              <h2 style="margin: 0; font-size: 32px; font-weight: 800; color: #000; line-height: 1.2;">
                ${headline}
              </h2>
              <p style="margin: 15px 0 0; font-size: 14px; color: #1a1a1a; line-height: 1.5;">
                Share the love & get rewarded for every successful referral
              </p>
            </td>
          </tr>
          
          <!-- MAIN CONTENT -->
          <tr>
            <td style="background: #ffffff; padding: 35px 30px;">
              
              <!-- Greeting -->
              <p style="margin: 0 0 20px; font-size: 16px; color: #333;">
                Dear <strong style="color: #D4AF37;">${customer_name}</strong>,
              </p>
              <p style="margin: 0 0 25px; font-size: 14px; color: #555; line-height: 1.7;">
                ${intro_message}
              </p>
              
              <!-- Big Reward Box -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 16px; margin-bottom: 25px; overflow: hidden;">
                <tr>
                  <td style="padding: 30px; text-align: center;">
                    <p style="margin: 0 0 5px; font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 2px;">Earn Up To</p>
                    <p style="margin: 0; font-size: 72px; font-weight: 800; color: #10B981; line-height: 1;">
                      £${referral_amount}
                    </p>
                    <p style="margin: 5px 0 0; font-size: 16px; color: #333; font-weight: 600;">Per Successful Referral</p>
                    <p style="margin: 10px 0 0; font-size: 13px; color: #666;">No limits - refer as many friends as you like!</p>
                  </td>
                </tr>
              </table>
              
              <!-- Your Referral Code -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 16px; margin-bottom: 25px;">
                <tr>
                  <td style="padding: 25px; text-align: center;">
                    <p style="margin: 0 0 10px; font-size: 12px; color: #D4AF37; text-transform: uppercase; letter-spacing: 2px;">Your Unique Referral Code</p>
                    <table border="0" cellpadding="0" cellspacing="0" style="background: linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%); border-radius: 12px; margin: 0 auto;">
                      <tr>
                        <td style="padding: 15px 40px;">
                          <p style="margin: 0; font-size: 28px; font-weight: 800; color: #000; letter-spacing: 3px; font-family: 'Courier New', monospace;">
                            ${refCode}
                          </p>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 15px 0 0; font-size: 12px; color: #888;">Share this code with your friends & family</p>
                  </td>
                </tr>
              </table>
              
              <!-- How It Works -->
              <h3 style="margin: 0 0 20px; font-size: 18px; font-weight: 700; color: #1a1a1a; text-align: center;">
                🎯 How It Works
              </h3>
              
              <!-- Step 1 -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 15px;">
                <tr>
                  <td width="50" style="vertical-align: top;">
                    <table border="0" cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="width: 40px; height: 40px; background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); border-radius: 50%; text-align: center; vertical-align: middle;">
                          <span style="color: #000; font-size: 18px; font-weight: 800; line-height: 40px;">1</span>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="padding-left: 15px; vertical-align: middle;">
                    <p style="margin: 0; font-size: 14px; color: #333; line-height: 1.5;">${how_it_works_1}</p>
                  </td>
                </tr>
              </table>
              
              <!-- Step 2 -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 15px;">
                <tr>
                  <td width="50" style="vertical-align: top;">
                    <table border="0" cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="width: 40px; height: 40px; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); border-radius: 50%; text-align: center; vertical-align: middle;">
                          <span style="color: #fff; font-size: 18px; font-weight: 800; line-height: 40px;">2</span>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="padding-left: 15px; vertical-align: middle;">
                    <p style="margin: 0; font-size: 14px; color: #333; line-height: 1.5;">${how_it_works_2}</p>
                  </td>
                </tr>
              </table>
              
              <!-- Step 3 -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 25px;">
                <tr>
                  <td width="50" style="vertical-align: top;">
                    <table border="0" cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="width: 40px; height: 40px; background: linear-gradient(135deg, #10B981 0%, #059669 100%); border-radius: 50%; text-align: center; vertical-align: middle;">
                          <span style="color: #fff; font-size: 18px; font-weight: 800; line-height: 40px;">3</span>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="padding-left: 15px; vertical-align: middle;">
                    <p style="margin: 0; font-size: 14px; color: #333; line-height: 1.5;">${how_it_works_3}</p>
                  </td>
                </tr>
              </table>
              
              <!-- Everyone Wins Box -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 12px; overflow: hidden; margin-bottom: 25px;">
                <tr>
                  <td width="50%" style="background: linear-gradient(135deg, #10B981 0%, #059669 100%); padding: 20px; text-align: center; vertical-align: top;" class="mobile-stack">
                    <p style="margin: 0 0 5px; font-size: 11px; color: rgba(255,255,255,0.8); text-transform: uppercase; letter-spacing: 1px;">You Get</p>
                    <p style="margin: 0; font-size: 36px; font-weight: 800; color: #fff;">£${referral_amount}</p>
                    <p style="margin: 5px 0 0; font-size: 12px; color: rgba(255,255,255,0.9);">Cash Reward</p>
                  </td>
                  <td width="50%" style="background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); padding: 20px; text-align: center; vertical-align: top;" class="mobile-stack">
                    <p style="margin: 0 0 5px; font-size: 11px; color: rgba(255,255,255,0.8); text-transform: uppercase; letter-spacing: 1px;">They Get</p>
                    <p style="margin: 0; font-size: 36px; font-weight: 800; color: #fff;">£${friend_discount}</p>
                    <p style="margin: 5px 0 0; font-size: 12px; color: rgba(255,255,255,0.9);">Off Their Move</p>
                  </td>
                </tr>
              </table>
              
              <!-- Share Buttons -->
              <h3 style="margin: 0 0 15px; font-size: 16px; font-weight: 700; color: #1a1a1a; text-align: center;">
                📤 Share Now
              </h3>
              
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 25px;">
                <tr>
                  <td align="center">
                    <table border="0" cellpadding="0" cellspacing="8">
                      <tr>
                        <td>
                          <a href="${whatsappLink}" style="display: inline-block; background: #25D366; color: #fff; font-size: 13px; font-weight: 600; text-decoration: none; padding: 12px 24px; border-radius: 25px;">
                            📱 WhatsApp
                          </a>
                        </td>
                        <td>
                          <a href="${smsLink}" style="display: inline-block; background: #1a1a1a; color: #fff; font-size: 13px; font-weight: 600; text-decoration: none; padding: 12px 24px; border-radius: 25px;">
                            💬 SMS
                          </a>
                        </td>
                        <td>
                          <a href="mailto:?subject=Save £25 on your next move!&body=${encodedShareMsg}" style="display: inline-block; background: #EA4335; color: #fff; font-size: 13px; font-weight: 600; text-decoration: none; padding: 12px 24px; border-radius: 25px;">
                            ✉️ Email
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              
              <!-- Sample Message -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8f9fa; border-radius: 12px; border-left: 4px solid #D4AF37; margin-bottom: 25px;">
                <tr>
                  <td style="padding: 18px;">
                    <p style="margin: 0 0 8px; font-size: 11px; color: #666; text-transform: uppercase; letter-spacing: 1px;">💡 Copy & Share This Message:</p>
                    <p style="margin: 0; font-size: 13px; color: #333; line-height: 1.6; font-style: italic;">
                      "Hey! I just moved with HomeGo Removals and they were absolutely brilliant - on time, careful with everything, and great value. If you're planning a move, use my code <strong style="color: #D4AF37;">${refCode}</strong> to get £25 off! Trust me, you won't regret it. 🏠📦"
                    </p>
                  </td>
                </tr>
              </table>
              
              <!-- Terms -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f1f5f9; border-radius: 8px;">
                <tr>
                  <td style="padding: 15px;">
                    <p style="margin: 0; font-size: 11px; color: #64748b; text-align: center;">
                      📋 <strong>Terms:</strong> ${terms_conditions}
                    </p>
                  </td>
                </tr>
              </table>
              
            </td>
          </tr>
          

          
          <!-- TRUST FOOTER -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 0 0 20px 20px; padding: 30px;">
              
              <!-- Trust Badges -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 20px;">
                <tr>
                  <td align="center">
                    <table border="0" cellpadding="0" cellspacing="15">
                      <tr>
                        <td style="background: rgba(212, 175, 55, 0.1); border: 1px solid rgba(212, 175, 55, 0.3); border-radius: 8px; padding: 10px 15px; text-align: center;">
                          <p style="margin: 0; font-size: 10px; color: #888;">🏛️ Company Reg</p>
                          <p style="margin: 3px 0 0; font-size: 12px; color: #D4AF37; font-weight: 600;">${company_reg_number}</p>
                        </td>
                        <td style="background: rgba(212, 175, 55, 0.1); border: 1px solid rgba(212, 175, 55, 0.3); border-radius: 8px; padding: 10px 15px; text-align: center;">
                          <p style="margin: 0; font-size: 10px; color: #888;">🛡️ Fully Insured</p>
                          <p style="margin: 3px 0 0; font-size: 12px; color: #D4AF37; font-weight: 600;">${insurance_amount}</p>
                        </td>
                        <td style="background: rgba(0, 182, 122, 0.1); border: 1px solid rgba(0, 182, 122, 0.3); border-radius: 8px; padding: 10px 15px; text-align: center;">
                          <p style="margin: 0; font-size: 10px; color: #888;">⭐ Trustpilot</p>
                          <p style="margin: 3px 0 0; font-size: 12px; color: #00B67A; font-weight: 600;">4.9/5 Rating</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              
              <!-- Company Info -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <p style="margin: 0 0 5px; font-size: 14px; font-weight: 700;">
                      <span style="color: #D4AF37;">Home</span><span style="color: #fff;">Go</span>
                      <span style="color: #666; font-weight: 400;"> Removals & Packing Ltd</span>
                    </p>
                    <p style="margin: 0 0 10px; font-size: 11px; color: #888;">
                      The UK's Most Trusted Removals Company
                    </p>
                    <p style="margin: 0; font-size: 12px; color: #D4AF37;">
                      📞 ${company_phone} | 📧 ${company_email}
                    </p>
                  </td>
                </tr>
              </table>
              
            </td>
          </tr>
          
        </table>
      </td>
    </tr>
  </table>
  
</body>
</html>
`;
};

export default generateAffiliateMarketingEmailHTML;
